/**
 * @see https://umijs.org/docs/max/access#access
 * */
import { Role } from '@/utils/constants';

export default function (initialState?: { currentUser?: API.CurrentUser }) {
  const { currentUser } = initialState || {};

  return {
    isAdmin: currentUser?.role === Role.admin,
    canAccessGame: (gameId: string) => {
      // Logic kiểm tra quyền truy cập game
      return true;
    },
    canAccessByRole: (roles: string[]) => {
      return !roles || !roles.length || roles.includes(currentUser?.role || '');
    },
  };
}
